import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import styled from "styled-components";

import AccountActivation from "./components/AccountActivation";
import Eula from "./components/Eula";
import Expired from "./components/Expired";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navigation from "./components/Navigation";
import PasswordActivation from "./components/PasswordActivation";
import Privacy from "./components/Privacy";
import PrivacyAppleArcade from "./components/PrivacyAppleArcade";
import Status from "./components/Status";
import Terms from "./components/Terms";
import TermsAppleArcade from "./components/TermsAppleArcade";
import { colors, device, paddingLarge, paddingSmall } from "./variables";

function App() {
  return (
    <Wrapper>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Navigation></Navigation>

        <Routes>
          <Route path="/status" element={<Status />} />
          <Route path="/eula" element={<ContentWrapper><Eula /></ContentWrapper>} />
          <Route path="/privacy" element={<ContentWrapper><Privacy /></ContentWrapper>} />
          <Route path="/privacy-aa" element={<ContentWrapper><PrivacyAppleArcade /></ContentWrapper>} />
          <Route path="/terms" element={<ContentWrapper><Terms /></ContentWrapper>} />
          <Route path="/terms-aa" element={<ContentWrapper><TermsAppleArcade /></ContentWrapper>} />

          <Route path="/account/en" element={<AccountActivation language={"en"} />} />
          <Route path="/account/ru" element={<AccountActivation language={"ru"} />} />
          <Route path="/account/es" element={<AccountActivation language={"es"} />} />
          <Route path="/account/de" element={<AccountActivation language={"de"} />} />
          <Route path="/account/fr" element={<AccountActivation language={"fr"} />} />
          <Route path="/account/pt" element={<AccountActivation language={"pt"} />} />
          <Route path="/account/tr" element={<AccountActivation language={"tr"} />} />
          <Route path="/account/pl" element={<AccountActivation language={"pl"} />} />

          <Route path="/password-activation/en" element={<><PasswordActivation language={"en"} /><Footer /></>} />
          <Route path="/password-activation/ru" element={<><PasswordActivation language={"ru"} /><Footer /></>} />
          <Route path="/password-activation/es" element={<><PasswordActivation language={"es"} /><Footer /></>} />
          <Route path="/password-activation/de" element={<><PasswordActivation language={"de"} /><Footer /></>} />
          <Route path="/password-activation/fr" element={<><PasswordActivation language={"fr"} /><Footer /></>} />
          <Route path="/password-activation/pt" element={<><PasswordActivation language={"pt"} /><Footer /></>} />
          <Route path="/password-activation/tr" element={<><PasswordActivation language={"tr"} /><Footer /></>} />
          <Route path="/password-activation/pl" element={<><PasswordActivation language={"pl"} /><Footer /></>} />

          <Route path="/expired/en" element={<><Expired language={"en"} /><Footer /></>} />
          <Route path="/expired/ru" element={<><Expired language={"ru"} /><Footer /></>} />
          <Route path="/expired/es" element={<><Expired language={"es"} /><Footer /></>} />
          <Route path="/expired/de" element={<><Expired language={"de"} /><Footer /></>} />
          <Route path="/expired/fr" element={<><Expired language={"fr"} /><Footer /></>} />
          <Route path="/expired/pt" element={<><Expired language={"pt"} /><Footer /></>} />
          <Route path="/expired/tr" element={<><Expired language={"tr"} /><Footer /></>} />
          <Route path="/expired/pl" element={<><Expired language={"pl"} /><Footer /></>} />

          <Route path="/" element={<><Home /><Footer /></>} />
        </Routes>
      </Router>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: ${colors.black};
  color: ${colors.white};
`;

const ContentWrapper = styled.div`
  padding: 0 ${paddingSmall};
  max-width: 2000px;
  margin: auto;
  @media ${device.laptop} {
    padding: 0 ${paddingLarge};
  }
`;

export default App;
